import {
  Text,
  View,
  ScrollView,
  StyleSheet,
  TouchableOpacity,
  TextInput,
  FlatList,
  StatusBar,
  Dimensions,
  Image
} from 'react-native'
import { Ionicons } from '@expo/vector-icons'
import * as React from 'react'
// styles

import { colorPalette, globalStyles } from '../../static/styles/global'

// i18n

// screens & components
import Card from '../../components/shared/card/Card'
import { Entypo, EvilIcons } from '@expo/vector-icons'
import { useEffect, useState } from 'react'
import { TabView, SceneMap, TabBar } from 'react-native-tab-view'
import CardSeparator from '../../components/shared/card/CardSeparator'
import CustomButton from '../../components/shared/button/Button'
import HomeDetailsHeader from '../../components/home/HomeDetailsHeader'

const OnboardedMessages = ({ navigation }): JSX.Element => {
  const [showHide, setShowHide] = React.useState(false)
  const listData = [
    {
      active: true,
      department: 'Human Resources',
      logo: 'hr.png',
      datetime: ''
    },
    {
      active: false,
      department: 'Meat Department',
      logo: 'meat.png',
      datetime: ''
    },
    {
      active: true,
      department: 'Product Department',
      logo: 'apple.png',
      datetime: ''
    },
    { active: true, department: 'Dairy', logo: 'dairy.png', datetime: '' },
    {
      active: true,
      department: 'Security',
      logo: 'security.png',
      datetime: ''
    },
    {
      active: true,
      department: 'Pharmacy',
      logo: 'pharmacy.png',
      datetime: ''
    },
    {
      active: true,
      department: 'Front of Store',
      logo: 'store.png',
      datetime: ''
    },
    {
      active: true,
      department: 'Cosmotics',
      logo: 'cosmotics.jpeg',
      datetime: ''
    }
  ]
  const updatesData = [
    {
      departments: 'Security',
      update: 'New Security Update',
      date: '09, Jul 2022'
    },
    {
      departments: 'Cosmotics',
      update: 'New Cosmotics Update',
      date: '19, Jul 2023'
    }
    // Add more updates data as needed
  ]

  const [searchText, setSearchText] = useState('')
  const [filteredData, setFilteredData] = useState(listData)
  const [filteredUpdatesData, setFilteredUpdatesData] = useState(updatesData)

  const handleSearch = (text) => {
    setSearchText(text)

    const filteredData = listData.filter((item) =>
      item.department.toLowerCase().includes(text.toLowerCase())
    )

    setFilteredData(filteredData)
    const filteredUpdatesData = updatesData.filter(
      (item) =>
        item.departments.toLowerCase().includes(text.toLowerCase()) ||
        item.date.includes(text)
    )
    setFilteredUpdatesData(filteredUpdatesData)
  }

  const FirstRoute = () => (
    <View style={[styles.container]}>
      <ScrollView>
        {filteredData.map((item, index) => {
          const imageSource = item.logo
            ? require(`../../../assets/Images/${item.logo}`)
            : null
          return (
            <View key={index}>
              <View style={{ flexDirection: 'row', padding: 0 }}>
                <View style={{ alignItems: 'center' }}>
                  <View
                    style={{
                      width: 7,
                      height: 7,
                      borderRadius: 10,
                      marginTop: 7,
                      backgroundColor: item.active ? 'green' : ''
                    }}
                  ></View>
                </View>
                <View>
                  <Image
                    source={imageSource}
                    style={{ width: 25, height: 25, marginLeft: 10 }}
                  />
                </View>
                <View style={{ marginLeft: 10 }}>
                  <TouchableOpacity
                    onPress={() => navigation.navigate('Department Messages')}
                  >
                    <Text style={{ fontSize: 15 }}>{item.department}</Text>
                  </TouchableOpacity>
                </View>
                <View style={{}}>
                  <Text style={{ fontSize: 12, textAlign: 'right' }}>
                    {item.datetime}
                  </Text>
                </View>
              </View>

              <CardSeparator />
            </View>
          )
        })}
      </ScrollView>
    </View>
  )
  const state = {
    index: 0,
    routes: [
      { key: 'first', title: 'All Group Messages' },
      {
        key: 'second',
        title: (
          <EvilIcons
            name="trash"
            size={34}
            color={index == 1 ? 'white' : '808080'}
          />
        )
      }
    ]
  }
  const SecondRoute = () => (
    <View style={{ marginTop: 20 }}>
      <View>
        <Text
          style={{
            color: 'red',
            fontStyle: 'italic',
            textAlign: 'center',
            fontSize: 13
          }}
        >
          Deleted messages will remain here for 30 days. after that they will be
          permanently deleted.
        </Text>
      </View>
      <ScrollView>
        {filteredUpdatesData.map((item, index) => (
          <View key={index}>
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                marginTop: 20
              }}
            >
              <View>
                <Text style={{ fontSize: 12, fontWeight: 'bold' }}>
                  {item.departments}
                </Text>
                <Text style={{ fontSize: 10 }}>{item.update}</Text>
              </View>
              <View
                style={{
                  flexDirection: 'row',
                  justifyContent: 'space-between'
                }}
              >
                <View style={{ marginLeft: 10 }}>
                  <Text style={{ fontSize: 10, textAlign: 'center' }}>
                    {item.date}
                  </Text>
                </View>

                <Entypo
                  name="cw"
                  size={20}
                  style={{ marginLeft: 20, color: 'blue' }}
                />
              </View>
            </View>
            <CardSeparator />
          </View>
        ))}
      </ScrollView>
    </View>
  )

  const [index, setIndex] = React.useState(0)

  const handelNewMessage = () => {
    navigation.navigate('MessageNew', {})
  }
  const renderTabBar = (props) => (
    <TabBar
      {...props}
      indicatorStyle={{
        backgroundColor: '#ffffff'
      }}
      style={{
        backgroundColor: '#0B495C'
      }}
      renderLabel={({ route, focused, color }) => (
        <Text style={{ color: focused ? '#ffffff' : '#808080' }}>
          {route.title}
        </Text>
      )}
    />
  )
  return (
    <ScrollView>
      {/* <UserBar /> */}
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        {/* <UserBar /> */}
        {/* <View>
          <TouchableOpacity
            style={{ flexDirection: 'row' }}
            onPress={() => navigation.navigate('LabourScreen')}
          >
            <Entypo name="chevron-left" size={22} color="white" />
            <Text style={{ color: 'white', fontSize: 20, flex: 1 }}>Home</Text>
          </TouchableOpacity>
        </View> */}
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader />
        </View>
        <View style={{ marginTop: 20, marginBottom: 0 }}>
          <Text
            style={{
              color: 'white',
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: 24
            }}
          >
            Messages
          </Text>
        </View>
      </View>
      <View style={[globalStyles.containerOverlap]}>
        <Card>
          <View>
            <TextInput
              style={[globalStyles.searchInput]}
              placeholder="Search"
              value={searchText}
              onChangeText={handleSearch}
            />
          </View>
          <View style={{ height: 500 }}>
            <TabView
              navigationState={state}
              renderScene={SceneMap({
                first: FirstRoute,
                second: SecondRoute
              })}
              onIndexChange={(index) => setIndex(index)}
              initialLayout={{ width: Dimensions.get('window').width }}
              style={[
                styles.container,
                { padding: 0, marginTop: 10, borderRadius: 10 }
              ]}
              // renderTabBar={(props) => (
              //   <TabBar
              //     {...props}
              //     style={{
              //       //width: '100%',
              //       backgroundColor: '#0B495C'
              //     }}
              //   />
              // )}
              renderTabBar={renderTabBar}
            />
          </View>
        </Card>
        <CustomButton text={'Create New Message'} onPress={handelNewMessage} />
      </View>
    </ScrollView>
  )
}
const styles = StyleSheet.create({
  custom: {
    justifyContent: 'center',
    flexDirection: 'row',
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 16,
    paddingRight: 16,
    alignItems: 'center',
    backgroundColor: '#0088CF',
    color: 'black',
    borderWidth: 0,
    width: '90%',
    marginTop: 10
  },
  customCardHeader: {
    justifyContent: 'center',
    flexDirection: 'row',
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 16,
    paddingRight: 16,
    alignItems: 'center',
    backgroundColor: '#0088CF',
    borderWidth: 0,
    width: '60%',
    marginTop: -18
  },
  myCard: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    backgroundColor: '#1978cd',
    marginBottom: 20,
    borderRadius: 5
  },
  dangerColor: {
    color: 'red',
    fontSize: 14
  },
  dayClass: {
    justifyContent: 'center',
    padding: 18
  },
  dayActive: {
    width: 6,
    height: 6,
    backgroundColor: 'black',
    borderRadius: 10,
    left: 2,
    marginTop: 10
  },
  container: {
    flex: 1,
    padding: 10
  },
  tabBar: {
    flexDirection: 'row',
    paddingTop: StatusBar.currentHeight
  },
  tabItem: {
    flex: 1,
    alignItems: 'center',
    padding: 0,
    backgroundColor: 'green'
  },
  pd10: {
    padding: 10
  }
})
export default OnboardedMessages
